import { AsynchronousNotification, AsynchronousNotificationType, AsynchronousNotificationWeight } from "../../../models/AsynchronousNotification";
import { IncomingCall } from "../../../models/IncomingCall";
import { formatTime } from "../../../utils/date";
import { text } from "../../../utils/i18n";
import { declineInboundCall } from "../service";

function getIncomingCallNotificationId(incomingCallNotificationId: string) {
  return `incoming-call-${incomingCallNotificationId}`;
}

export function createIncomingCallNotification(call: IncomingCall, incomingCallNotificationId: string, onAnswer?: () => void) {
  const shortDescription = call.isTransferred ? text`Vidarekopplat samtal` : text`Inkommande samtal`;

  return new AsynchronousNotification({
    id: getIncomingCallNotificationId(incomingCallNotificationId),
    type: AsynchronousNotificationType.IncomingCall,
    weight: AsynchronousNotificationWeight.Urgent,
    documentTitle: call.isTransferred ? text`${call.recipient} ringer` : text`${call.caller} ringer`,
    title: call.isInbound ? call.caller : call.recipient,
    body: () => {
      if (call.isTransferred) {
        //  connectedAt for transferred calls.
        return call.connectedAt ? `${shortDescription}: ${formatTime(Date.now() - call.connectedAt.getTime())}` : shortDescription;
      }

      //  connectingAt for inbound calls.
      return call.connectingAt ? `${shortDescription}: ${formatTime(Date.now() - call.connectingAt.getTime())}` : shortDescription;
    },
    bodyUpdateInterval: 1000,
    icon: { name: "phone" },
    tags: [call.id], // Allows us to delete the notification with only call ID.
    actions: {
      confirm: {
        children: text`Svara`,
        icon: "phone",
        onClick: async (params) => {
          onAnswer?.();
          await params.telephonyContext.answerCall(call);
        }
      },
      dismiss: {
        children: text`Neka`,
        icon: "ban",
        weight: "danger",
        onClick: () => {
          //  No need to await. On error, then ringing will time out.
          declineInboundCall(call.id).catch(error => {
            if (error.message !== "notFoundError") {
              console.error("alert: Could not decline inbound call", {
                call,
                error: {
                  ...error,
                  name: error.name,
                  message: error.message
                }
              });
            }
          });
        }
      }
    }
  });
}